<ng-container *ngIf="selectedLocation()">
  <div *ngIf="selectedLocation()" class="carousel">
    <div class="carousel__scroller">
      @for (tuple of getCampaignWithSingleLocation(); track tuple) {
        <section
          class="carousel__group"
          id="{{ componentId }}-group-{{ getCampaignWithSingleLocation().indexOf(tuple) }}">
          <ng-container>
            <lib-swipeable (swipeLeft)="navToNext()" (swipeRight)="navToPrev()">
              <app-map-marker-details-card class="carousel__item" [campaign]="tuple.campaign"
                                           [address]="tuple.location.address"
                                           [campaignUserStatus]="campaignsUserStatus()"></app-map-marker-details-card>
            </lib-swipeable>
          </ng-container>
        </section>
      }
    </div>
  </div>
</ng-container>
